// extracted by mini-css-extract-plugin
export default {"head":"Accordian_head__JyM6D","titletext":"Accordian_titletext__aXCiO","arrow":"Accordian_arrow__ZYD6k"};